import type { InjectionKey } from 'vue'
import { provide } from 'vue'

import { injectRequired } from '@/utils/use-vue/index.ts'

import type { ImageUtils } from './types.ts'

export const injectImageUtilsKey: InjectionKey<ImageUtils> = Symbol('image-utils')

export function useRequiredInjectImageUtils(): ImageUtils {
  return injectRequired(injectImageUtilsKey)
}

export function useProvideImageUtils(fns: ImageUtils): void {
  provide(injectImageUtilsKey, fns)
}
